import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { ConsultaComplementoGeneralOutput, ConsultaSiniestroOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from '../../../../@store/actions';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { CrearActualizarTercerosComponent } from '../../@components/crear-actualizar-terceros/crear-actualizar-terceros.component';

@Component({
    selector: 'app-modal-consultar-terceros',
    templateUrl: './modal-consultar-terceros.component.html',
    styleUrls: ['./modal-consultar-terceros.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, CrearActualizarTercerosComponent]
})
export class ModalConsultarTercerosComponent implements OnDestroy {

  public tercerosComplemento = new MatTableDataSource([]);
  public siniestroConsultado: string;
  public detalleSeccionSiniestroComplemento: ConsultaComplementoGeneralOutput;
  private listaObservables = new Subscription();
  public detalleSiniestroComplemento: ConsultaSiniestroOutput;

  constructor(
    public dialogRef: MatDialogRef<ModalConsultarTercerosComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosWebService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: { modulo: string, tipoTercero: number },
  ) {
    this.obtenerReduxState();
    console.log(this.data, 'modal terceros')
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.siniestroConsultado = siniestro;
      this.detalleSiniestroComplemento = detalleSiniestro?.siniestroDetalle;
      this.consultarComplementoWeb(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string, valor?: any) {
    if (opcion == 'Cancelar') this.dialogRef.close(valor);
    if (opcion == 'Aceptar') this.dialogRef.close(valor);
  }

  consultarComplementoWeb(siniestro: string) {
    const siniestroFormateado = this.procesosWebService.devolverSiniestro(siniestro);
    const { tipoTerceros, validaTercero } = this.procesaTiposServicios();
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      causa: this.detalleSiniestroComplemento.Siniestro[0].causa,
      modulo: this.data.modulo,
      tipoServicio: this.data.tipoTercero,
      tiposTercero: tipoTerceros,
      validaTipoTercero: validaTercero,
    }
    console.log(request)
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaComplementoGeneral(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado != null) {
          this.detalleSeccionSiniestroComplemento = value.Resultado;
          this.tercerosComplemento = new MatTableDataSource(this.detalleSeccionSiniestroComplemento.Terceros);
        } else {
          this.procesosWebService.alertaGeneralComplemento('Aviso', `No se encontró el detalle del siniestro.`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos del complemento.' }));
      },
    })
  }

  procesaTiposServicios(): { tipoTerceros: string, validaTercero: boolean } {
    const { modulo, tipoTercero } = this.data;

    if (modulo === 'Lesionados') {
      return { tipoTerceros: '1,4,5', validaTercero: true };
    }

    if (modulo === 'Servicios') {
      const mapa: Record<number, { tipoTerceros: string; validaTercero: boolean }> = {
        1: { tipoTerceros: '1', validaTercero: true },
        5: { tipoTerceros: '1', validaTercero: false },
        10: { tipoTerceros: '1,4,5', validaTercero: true },
        16: { tipoTerceros: '1,4,5', validaTercero: true },
        17: { tipoTerceros: '1,4,5', validaTercero: true },
        23: { tipoTerceros: '2,3', validaTercero: true },
      };

      return mapa[tipoTercero] ?? { tipoTerceros: '', validaTercero: false };
    }

    return { tipoTerceros: '', validaTercero: false };
  }

  procesarEventosTerceros(evento: { nombre: string, valor: any }) {
    if (evento.nombre == 'SELECCION_TERCERO') {
      this.closeDialog('Aceptar', evento.valor);
    }
  }
}
